import { createGlobalStyle as m, ThemeProvider as h, styled as n, css as i } from "styled-components";
import { jsxs as x, jsx as r } from "react/jsx-runtime";
import "react";
const w = {
  font: {
    family: {
      base: "'Noto Sans', Arial, sans-serif"
    }
  }
}, f = {
  blue99: "#f3fdff",
  blue95: "#daf4ff",
  blue90: "#b7e8ff",
  blue80: "#74cfff",
  blue70: "#18b7f7",
  blue60: "#00a6ee",
  blue40: "#0078c1",
  blue50: "#0091df",
  blue30: "#005fab",
  blue20: "#00478c",
  blue10: "#00366c",
  darkBlue99: "#f7fcff",
  darkBlue95: "#e4f0ff",
  darkBlue90: "#cee1ff",
  darkBlue80: "#a8c5ff",
  darkBlue70: "#7daaff",
  darkBlue60: "#4790f9",
  darkBlue50: "#0077ed",
  darkBlue40: "#0060e1",
  darkBlue30: "#004bd6",
  darkBlue20: "#0038c1",
  darkBlue10: "#0028ad",
  transparent: "rgba(255, 255, 255, 0)",
  black100: "#ffffff",
  black99: "#f8f9fa",
  black95: "#eef1f4",
  black90: "#dde3ea",
  black80: "#bfc7d1",
  black70: "#a2acb7",
  black60: "#87929e",
  black50: "#6c7886",
  black40: "#52606e",
  black30: "#394857",
  black20: "#213241",
  black10: "#081d2d",
  green99: "#d1ffe6",
  green95: "#99f7c4",
  green90: "#7cecb0",
  green80: "#59d994",
  green70: "#4ac684",
  green60: "#33b36e",
  green50: "#289f5e",
  green40: "#268b54",
  green30: "#11703c",
  green20: "#065128",
  green10: "#00381a",
  yellow99: "#fffad5",
  yellow95: "#ffec8f",
  yellow90: "#ffdd6d",
  yellow80: "#ffd240",
  yellow70: "#ffc710",
  yellow60: "#ffa903",
  yellow50: "#f4890a",
  yellow40: "#e16105",
  yellow30: "#ac4a03",
  yellow20: "#7a3503",
  yellow10: "#4e2202",
  red99: "#fff6f9",
  red95: "#ffe3eb",
  red90: "#ffcedb",
  red80: "#ffaabc",
  red70: "#ff859f",
  red60: "#f05e83",
  red50: "#de2d68",
  red40: "#cb004e",
  red30: "#b60041",
  red20: "#9a0034",
  red10: "#7f0020",
  purple99: "#fefbff",
  purple95: "#f8edff",
  purple90: "#f0dbfe",
  purple80: "#e0b7fd",
  purple70: "#cd93fb",
  purple60: "#b573ec",
  purple50: "#9b53dc",
  purple40: "#8131cc",
  purple30: "#6f00c4",
  purple20: "#5a00a4",
  purple10: "#4a008c"
}, g = {
  ...f,
  icon: "#0091DF"
}, j = Object.keys(f), C = [10, 12, 14, 16, 20, 24, 26, 32, 40, 48], k = {
  size: {
    10: "10px",
    12: "12px",
    14: "14px",
    16: "16px",
    20: "20px",
    24: "24px",
    26: "26px",
    32: "32px",
    40: "40px",
    48: "48px"
  }
}, a = {
  desktop: "1440px",
  tablet: "1080px",
  tabletMd: "1024px",
  tabletSm: "768px",
  phone: "640px",
  phoneSm: "320px"
}, t = {
  desktop: 1440,
  tablet: 1080,
  tabletMd: 1024,
  tabletSm: 768,
  phone: 640,
  phoneSm: 320
}, y = {
  name: "default",
  colors: g,
  icons: k,
  zIndex: {
    modal: 1080,
    tooltip: 999,
    datePicker: 959,
    toast: 9999,
    header: {
      overlay: 1060,
      menu: 1062,
      container: 1061
    },
    sticky: 1062
  },
  fontFamily: w.font.family.base,
  up: (e) => `@media (min-width: ${a[e]})`,
  down: (e) => `@media (max-width: ${a[e]})`,
  between: (e, o) => `@media (min-width: ${a[e]}) and (max-width: ${a[o]})`
}, N = (e, o) => o in e.colors, E = (e) => {
  const o = z(e);
  return ["phone", "phoneSm"].includes(o) ? "mobile" : ["tablet", "tabletMd", "tabletSm"].includes(o) ? "tablet" : "desktop";
}, z = (e) => e < t.phone ? "phoneSm" : e >= t.phone && e < t.tabletSm ? "phone" : e >= t.tabletSm && e < t.tabletMd ? "tabletSm" : e >= t.tabletMd && e < t.tablet ? "tabletMd" : e >= t.tablet && e < t.desktop ? "tablet" : "desktop", v = "/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */html{line-height:1.15;-webkit-text-size-adjust:100%}body{margin:0}main{display:block}h1{font-size:2em;margin:.67em 0}hr{box-sizing:content-box;height:0;overflow:visible}pre{font-family:monospace,monospace;font-size:1em}a{background-color:transparent}abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}b,strong{font-weight:bolder}code,kbd,samp{font-family:monospace,monospace;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}img{border-style:none}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;line-height:1.15;margin:0}button,input{overflow:visible}button,select{text-transform:none}button,[type=button],[type=reset],[type=submit]{-webkit-appearance:button}button::-moz-focus-inner,[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner{border-style:none;padding:0}button:-moz-focusring,[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring{outline:1px dotted ButtonText}fieldset{padding:.35em .75em .625em}legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}progress{vertical-align:baseline}textarea{overflow:auto}[type=checkbox],[type=radio]{box-sizing:border-box;padding:0}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}details{display:block}summary{display:list-item}template{display:none}[hidden]{display:none}", S = m`
  ${v}

  img {
    max-width: 100%;
    height: auto;
    object-fit: contain;
  }

  body {
    min-width: ${a.phoneSm};
  }

  body,
  button,
  input {
    font-family: ${({ theme: e }) => e.fontFamily};
    color: ${({ theme: e }) => e.colors.black10};
  }
  p,
  a,
  h1,
  h2,
  h3,
  h4,
  h5,
  input,
  hr,
  button,
  section,
  menu {
    margin: 0;
    padding: 0;
  }
  div,
  section,
  input,
  button {
    box-sizing: border-box;
  }
  input {
    outline: none;
  }
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  textarea:-webkit-autofill,
  textarea:-webkit-autofill:hover,
  textarea:-webkit-autofill:focus,
  select:-webkit-autofill,
  select:-webkit-autofill:hover,
  select:-webkit-autofill:focus {
    transition: background-color 100s ease-in-out 0s;
  }
  button {
    border: none;
  }
`, F = (e, { theme: o = y, useGlobalStyles: d }) => {
  const c = e.displayName || e.name || "Component", l = (u) => /* @__PURE__ */ x(h, { theme: o, children: [
    d && /* @__PURE__ */ r(S, {}),
    /* @__PURE__ */ r(e, { ...u })
  ] });
  return l.displayName = `withTheme(${c})`, l;
}, B = n.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  min-height: 16px;
  font-size: 13px;
`;
n.div`
  display: flex;
`;
n.p`
  font-weight: 700;
  font-size: 10px;
  line-height: 1;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  white-space: nowrap;
  margin: 0;
`;
n.div`
  display: flex;
`;
n(B)`
  margin-bottom: 0;
  margin-top: 8px;
  min-height: 1em;
  font-size: 16px;
`;
n.div`
  display: flex;
  align-items: center;
`;
n.p`
  font-size: 13px;
  line-height: 1;
  letter-spacing: 0.1px;
  color: ${({ theme: e }) => e.colors.red50};
`;
i`
  font-family: inherit;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;

  ${({ theme: { down: e } }) => e("tablet")} {
    font-size: 14px;
  }
`;
const s = "0px 1px 8px rgba(0, 0, 0, 0.17)", b = "0px 4px 20px rgba(0, 0, 0, 0.07)", p = "0px 4px 28px rgba(0, 0, 0, 0.14)", I = i`
  -webkit-filter: blur(0);
  will-change: filter;
  filter: drop-shadow(${s});
`, G = i`
  -webkit-filter: blur(0);
  will-change: filter;
  filter: drop-shadow(${b});
`, L = i`
  -webkit-filter: blur(0);
  will-change: filter;
  filter: drop-shadow(${p});
`, P = i`
  box-shadow: ${s};
  -webkit-filter: blur(0);
  filter: blur(0);
`, A = i`
  box-shadow: ${b};
  -webkit-filter: blur(0);
  filter: blur(0);
`, D = i`
  box-shadow: ${p};
  -webkit-filter: blur(0);
  filter: blur(0);
`;
export {
  a as Breakpoints,
  S as GlobalStyles,
  t as NumericBreakpoints,
  P as boxShadow1,
  A as boxShadow2,
  D as boxShadow3,
  g as defaultColors,
  y as defaultTheme,
  E as getBreakpoint,
  z as getBreakpointName,
  C as iconSizes,
  N as isThemeColor,
  I as shadowElevation1,
  G as shadowElevation2,
  L as shadowElevation3,
  j as themeColorList,
  F as withTheme
};
